enum KnowledgeBaseVisibilityType {
  Company = 'COMPANY',
  Author = 'AUTHOR',
  UsersList = 'USERS_LIST'
}

export { KnowledgeBaseVisibilityType }
